import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

function MapView({ devices }) {
  const parsedDevices = Object.entries(devices)
    .map(([deviceID, location]) => {
      const [lat, lng] = location.split(",").map(Number);
      if (!isNaN(lat) && !isNaN(lng)) {
        return { deviceID, lat, lng };
      }
      return null;
    })
    .filter(Boolean);

  if (parsedDevices.length === 0) {
    return <div>No devices to display on the map.</div>;
  }

  const defaultCenter = [parsedDevices[0].lat, parsedDevices[0].lng];

  const getGlowIcon = (color) => {
    return L.divIcon({
      className: "custom-glow-marker",
      html: `
        <div style="
          width: 20px;
          height: 20px;
          background-color: ${color};
          border-radius: 50%;
          border: 3px solid rgba(255, 255, 255, 0.4);
          box-shadow: 0 0 15px 6px ${color}66;
          display: flex;
          justify-content: center;
          align-items: center;
        ">
          <div style="
            width: 10px;
            height: 10px;
            background-color: ${color};
            border-radius: 50%;
          "></div>
        </div>
      `,
      iconSize: [24, 24],
      iconAnchor: [12, 12],
    });
  };

  const getColor = (index) => {
    const colors = ["#00c9a7", "#facc15", "#ef4444", "#fde047", "#3b82f6", "#a855f7", "#f472b6", "#22d3ee"];
    return colors[index % colors.length];
  };

  return (
    <div>
      <div
        style={{
          height: "580px",
          width: "700px",
          borderRadius: "12px",
          overflow: "hidden",
          backgroundColor: "#151C23",
        }}
      >
        <MapContainer
          center={defaultCenter}
          zoom={6}
          minZoom={2}
          maxZoom={22}
          style={{ height: "100%", width: "100%", zIndex: 1 }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {parsedDevices.map((device, index) => {
            const color = getColor(index);
            return (
              <Marker
                key={device.deviceID}
                position={[device.lat, device.lng]}
                icon={getGlowIcon(color)}
              >
                <Popup>
                  <strong>{device.deviceID}</strong><br />
                  Lat: {device.lat}<br />
                  Lng: {device.lng}
                </Popup>
              </Marker>
            );
          })}
        </MapContainer>
      </div>
    </div>
  );
}

export default MapView;
